import { RootState } from "@/store/store";
import { SavingsPlanRecommendation } from "@/services/cloudchipr.api";
import { commitmentsRecommendationsGridDataSelector } from "@/store/commitments/selectors/recommendations/data/commitmentsRecommendationsGridDataSelector";
import { filterSavingsPlansRecommendationsByFilters } from "@/store/commitments/utils/helpers/filterSavingsPlansRecommendationsByFilters";
import { recommendationsDefaultFilters } from "@/store/commitments/utils/constants";

export const commitmentsRecommendationsOverviewGridDataSelector = (
  state: RootState,
): (SavingsPlanRecommendation & { id: string })[] | undefined => {
  const data = commitmentsRecommendationsGridDataSelector(state);

  return filterSavingsPlansRecommendationsByFilters(
    recommendationsDefaultFilters,
    data,
  );
};
